import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnmute = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.5534 3.06413C11.8249 3.18423 12 3.45315 12 3.75001V20.25C12 20.5469 11.8249 20.8158 11.5534 20.9359C11.2819 21.056 10.9652 21.0047 10.7455 20.805L5.46004 16H2.75C1.7835 16 1 15.2165 1 14.25V9.75001C1 8.78352 1.7835 8.00001 2.75 8.00001H5.46004L10.7455 3.19506C10.9652 2.99537 11.2819 2.94403 11.5534 3.06413ZM10.5 5.44543L6.2545 9.30497C6.11645 9.43047 5.93657 9.50001 5.75 9.50001H2.75C2.61193 9.50001 2.5 9.61194 2.5 9.75001V14.25C2.5 14.3881 2.61193 14.5 2.75 14.5H5.75C5.93657 14.5 6.11645 14.5696 6.2545 14.6951L10.5 18.5546V5.44543Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.7175 4.22183C19.0104 3.92893 19.4853 3.92893 19.7782 4.22183C24.0739 8.51759 24.0739 15.4824 19.7782 19.7782C19.4853 20.0711 19.0104 20.0711 18.7175 19.7782C18.4246 19.4853 18.4246 19.0104 18.7175 18.7175C22.4275 15.0075 22.4275 8.99247 18.7175 5.28249C18.4246 4.98959 18.4246 4.51472 18.7175 4.22183Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.2426 7.75738C15.9497 7.46449 15.4748 7.46449 15.182 7.75738C14.8891 8.05027 14.8891 8.52515 15.182 8.81804C16.9393 10.5754 16.9393 13.4246 15.182 15.182C14.8891 15.4749 14.8891 15.9498 15.182 16.2427C15.4748 16.5356 15.9497 16.5356 16.2426 16.2427C18.5858 13.8995 18.5858 10.1005 16.2426 7.75738Z",
			fill: "var(--colors-grey-1)"
		})
	]
});
export default SvgUnmute;
